import React from 'react'
import cn from 'classnames'
import styles from './styles.module.css'

interface SectionProps {
  children: React.ReactNode
  fullOnlyOnMobile?: boolean
  hasBackgroundColor?: boolean
  gridArea?: string
  id?: string
  hidden?: boolean
}

const Section = React.forwardRef<HTMLDivElement, SectionProps>((props, ref) => {
  const {
    children,
    fullOnlyOnMobile = false,
    hasBackgroundColor = false,
    gridArea = null,
    id,
    hidden = false,
  } = props

  if (hidden) return null

  return (
    <div
      className={cn(styles.contentWrapper, {
        [styles.fullOnlyOnMobile]: fullOnlyOnMobile,
        [styles.hasBackgroundColor]: hasBackgroundColor,
      })}
      id={id}
      ref={ref}
    >
      <div
        className={cn(styles.containerConstrain, {
          [styles.fullOnlyOnMobile]: fullOnlyOnMobile,
        })}
        {...(gridArea && { style: { gridArea } })}
      >
        {children}
      </div>
    </div>
  )
})

export default Section
